module.exports = __webpack_public_path__ + "img/email.501c598d.svg";